import * as bootstrap from 'bootstrap';

const SELECTOR = '[data-data-table-tooltip-popover]';
const INITIALIZED_FLAG = 'dataTableTooltipPopoverInitialized';

function applyPopoverMaxWidth(element) {
    if (!(element instanceof HTMLElement)) {
        return;
    }

    const maxWidth = getComputedStyle(element).getPropertyValue('--data-table-tooltip-max-width').trim();
    if (!maxWidth) {
        return;
    }

    const popoverId = element.getAttribute('aria-describedby');
    const popoverElement = popoverId ? document.getElementById(popoverId) : null;
    if (!popoverElement) {
        return;
    }

    popoverElement.style.setProperty('--data-table-tooltip-max-width', maxWidth);
}

function hideAllPopovers(exceptElement = null) {
    document.querySelectorAll(SELECTOR).forEach((el) => {
        if (exceptElement && el === exceptElement) {
            return;
        }
        bootstrap?.Popover?.getInstance(el)?.hide();
    });
}

function initDataTableTooltipPopovers(root = document) {
    if (!bootstrap || typeof bootstrap.Popover !== 'function') {
        return;
    }

    const elements = [];

    if (root instanceof Element && root.matches(SELECTOR)) {
        elements.push(root);
    }

    if (typeof root.querySelectorAll === 'function') {
        root.querySelectorAll(SELECTOR).forEach((element) => elements.push(element));
    }

    elements.forEach((element) => {
        if (!(element instanceof HTMLElement) || element.dataset[INITIALIZED_FLAG] === '1') {
            return;
        }

        const content = (element.getAttribute('data-popover-text') || '').trim();
        if (!content) {
            return;
        }

        const popover = new bootstrap.Popover(element, {
            trigger: 'hover',
            placement: 'bottom',
            fallbackPlacements: ['top'],
            container: 'body',
            content,
            customClass: 'data-table__tooltip-popover',
            sanitize: true
        });

        element.addEventListener('show.bs.popover', (e) => {
            const tr = element.closest('tr.data-table__row');
            if (!element.isConnected || element.offsetParent === null || (tr && tr.classList.contains('shown'))) {
                e.preventDefault();
                return;
            }
            // Zavřít všechny ostatní tooltipy po otevření tohoto
            hideAllPopovers(element);
        });

        element.addEventListener('shown.bs.popover', () => {
            const tr = element.closest('tr.data-table__row');
            if (!element.isConnected || element.offsetParent === null || (tr && tr.classList.contains('shown'))) {
                popover.hide();
                return;
            }
            applyPopoverMaxWidth(element);
        });

        element.addEventListener('click', () => {
            hideAllPopovers();
        });

        element.dataset[INITIALIZED_FLAG] = '1';
    });
}

function initDataTableTooltipPopoverObserver() {
    if (typeof window === 'undefined' || window.__sppkDataTableTooltipPopoverObserver) {
        return;
    }

    const start = () => {
        if (!document.body || window.__sppkDataTableTooltipPopoverObserver) {
            return;
        }

        initDataTableTooltipPopovers(document);

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (!(node instanceof Element)) {
                        return;
                    }

                    initDataTableTooltipPopovers(node);
                });
            });
        });

        observer.observe(document.body, { childList: true, subtree: true });
        window.__sppkDataTableTooltipPopoverObserver = observer;
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start, { once: true });
        return;
    }

    start();
}

if (typeof document !== 'undefined') {
    document.addEventListener('pointerdown', (e) => {
        if (e.target instanceof Element && e.target.closest(SELECTOR)) {
            return;
        }
        hideAllPopovers();
    }, { passive: true });

    document.addEventListener('click', (e) => {
        if (e.target instanceof Element && e.target.closest(SELECTOR)) {
            return;
        }
        hideAllPopovers();
    });

    ['show.bs.dropdown', 'show.bs.collapse', 'show.bs.modal', 'show.bs.offcanvas'].forEach((eventType) => {
        document.addEventListener(eventType, () => hideAllPopovers());
    });
}

if (typeof window !== 'undefined') {
    window.initDataTableTooltipPopovers = initDataTableTooltipPopovers;
    window.hideAllDataTableTooltipPopovers = hideAllPopovers;
}

initDataTableTooltipPopoverObserver();

export default initDataTableTooltipPopovers;
